import React from 'react';
import { motion } from 'framer-motion';
import { MenuItem } from '../data/businesses';
interface MenuShowcaseProps {
  items: MenuItem[];
}
export function MenuShowcase({
  items
}: MenuShowcaseProps) {
  if (!items || items.length === 0) return null;
  return <section className="bg-white py-24 px-6 border-t border-[#c9a961]/10" data-id="element-174">
      <div className="max-w-7xl mx-auto" data-id="element-175">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-16" data-id="element-176">
          <span className="text-[#c9a961] text-[13px] font-bold tracking-[0.2em] uppercase mb-4 block" data-id="element-177">
            Culinary Highlights
          </span>
          <h2 className="font-display text-[40px] md:text-[56px] font-medium text-[#1d1d1f] mb-6" data-id="element-178">
            Signature Dishes
          </h2>
          <div className="w-20 h-[1px] bg-[#c9a961] mx-auto mb-8" data-id="element-179" />
          <p className="text-[#86868b] text-[18px] max-w-2xl mx-auto font-light leading-relaxed" data-id="element-180">
            A curated selection of our most loved creations, prepared with
            passion and authenticity.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-181">
          {items.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: index * 0.1
        }} className="group" data-id="element-182">
              <div className="relative aspect-square overflow-hidden rounded-sm mb-6 bg-[#f2f2f4]" data-id="element-183">
                <img src={item.image} alt={item.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-184" />
                <div className="absolute inset-0 bg-black/20 group-hover:bg-transparent transition-colors duration-500" data-id="element-185" />
              </div>
              <div className="text-center" data-id="element-186">
                <h3 className="font-display text-[22px] font-medium text-[#1d1d1f] mb-2 group-hover:text-[#c9a961] transition-colors" data-id="element-187">
                  {item.name}
                </h3>
                <p className="text-[#86868b] text-[15px] font-light mb-3 line-clamp-2" data-id="element-188">
                  {item.description}
                </p>
                <span className="text-[#c9a961] text-[16px] font-bold tracking-wide" data-id="element-189">
                  {item.price}
                </span>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}